import { Box, BoxProps } from "@biblioteksentralen/react";
import { SVGProps } from "react";
import { useTransitionProps } from "../utils";

const BowTieSVG = (pathProps: SVGProps<SVGPathElement>) => (
  <svg width="60%" viewBox="0 0 31 26" fill="none" aria-hidden>
    <path
      d="M29.2756 3.0733C28.9304 1.44906 27.3314 0.414229 25.7082 0.764568L9.70799 4.21803C5.60988 5.10256 2.49859 8.44952 1.91511 12.6012L0.408583 23.3207C0.215382 24.6954 1.4471 25.844 2.80494 25.5553L22.922 21.2793C28.3242 20.1311 31.7726 14.8209 30.6244 9.41874L29.2756 3.0733Z"
      {...pathProps}
    />
  </svg>
);

const BowTieWrapper = ({
  children,
  transitionProperty,
  transitionTimingFunction,
  transitionDuration,
  transitionDelay,
  ...boxProps
}: BoxProps) => (
  <Box
    position="absolute"
    top="-6%"
    css={`
      svg path {
        transition-property: ${transitionProperty};
        transition-timing-function: ${transitionTimingFunction};
        transition-duration: ${transitionDuration};
        transition-delay: ${transitionDelay};
      }
    `}
    {...boxProps}
  >
    {children}
  </Box>
);

type Props = {
  placement: "left" | "right";
  transitionDelay?: BoxProps["transitionDelay"];
  fill: string;
};

export const BowTie = ({ placement, transitionDelay, fill }: Props) => {
  const transitionProps = useTransitionProps();
  const left = placement === "left" ? undefined : "50%";
  const right = placement === "left" ? "50%" : undefined;
  const transform =
    placement === "left" ? "translateY(-100%) rotate(7deg) scaleX(-1)" : "translateY(-100%) rotate(-7deg)";

  return (
    <BowTieWrapper
      left={left}
      right={right}
      transform={transform}
      transitionDelay={transitionDelay}
      {...transitionProps}
    >
      <BowTieSVG fill={fill} />
    </BowTieWrapper>
  );
};
